/**
 * LaunchDarkly flag for the household Overview page revamp.
 *
 * - **LD key (Rails + this file):** `flag-household-page-revamp`
 * - **FE camelCase (`useFlags()`):** `flagHouseholdPageRevamp`
 */
export const HOUSEHOLD_PAGE_REVAMP_FLAG = 'flag-household-page-revamp';

export const HOUSEHOLD_PAGE_REVAMP_FLAG_CAMEL = 'flagHouseholdPageRevamp';
